var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      staticClass: "cms-breadcrumbs-block",
      attrs: { "aria-label": "Breadcrumb" },
    },
    [
      _c(
        "ol",
        { staticClass: "cms-breadcrumbs-block__list" },
        _vm._l(_vm.resolvedCrumbs, function (crumb, idx) {
          return _c(
            "li",
            { key: idx, staticClass: "cms-breadcrumbs-block__item" },
            [
              !crumb.current
                ? _c(
                    "a",
                    {
                      staticClass: "cms-breadcrumbs-block__link",
                      style: _vm.linkStyle,
                      attrs: { href: crumb.url || "#" },
                    },
                    [
                      idx === 0 && _vm.showHomeResolved && _vm.homeIcon
                        ? _c("i", {
                            staticClass: "cms-breadcrumbs-block__home-icon",
                            class: "fa fa-" + _vm.homeIcon,
                          })
                        : _vm._e(),
                      _vm._v(_vm._s(crumb.label)),
                    ]
                  )
                : _c(
                    "span",
                    {
                      staticClass: "cms-breadcrumbs-block__current",
                      style: _vm.currentStyle,
                      attrs: { "aria-current": "page" },
                    },
                    [_vm._v(_vm._s(crumb.label))]
                  ),
              _vm._v(" "),
              idx < _vm.resolvedCrumbs.length - 1
                ? _c(
                    "span",
                    {
                      staticClass: "cms-breadcrumbs-block__separator",
                      style: _vm.separatorStyle,
                      attrs: { "aria-hidden": "true" },
                    },
                    [_vm._v(_vm._s(_vm.separator))]
                  )
                : _vm._e(),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }